import { createFileRoute } from '@tanstack/react-router'
import { CREDIT_ROUTES, toStaticData } from '../../credit-route-config'

export const Route = createFileRoute('/_auth/_modules/credit/blocked-orders/resolved')({
  staticData: toStaticData(CREDIT_ROUTES['/credit/blocked-orders/resolved']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
